export default __webpack_public_path__ + "static/media/logos6.a5533a52.png";